import { createAction, props, createReducer, on } from '@ngrx/store';
import { PartnerDataInitState } from '../models/partner.interface';

// Define action creators using createAction
export const UPDATE_PARTNER_NAME = createAction(
  '[Partner] Update Partner Name',  // Action type
  props<{ partnerName: string }>()  // Payload
);

export const REFRESH_PARTNER = createAction(
  '[Partner] Refresh Partner',  // Action type
  props<{ partnerDetails: any }>()  // Payload (you can adjust the type of partnerDetails as needed)
);

export const RESET_PARTNER = createAction(
  '[Partner] Reset Partner'  // Action type (no payload)
);

// Initial state
const initState: PartnerDataInitState = {
  partnerName: 'NONE',
};

// Define the reducer using createReducer and on
export const partnerReducer = createReducer(
  initState,  // Initial state

  // Handle the UPDATE_PARTNER_NAME action
  on(UPDATE_PARTNER_NAME, (state, { partnerName }) => ({
    ...state,  // Keep the existing state
    partnerName,  // Update partnerName in state
  })),

  // Handle the REFRESH_PARTNER action
  on(REFRESH_PARTNER, (state, { partnerDetails }) => ({
    ...state,  // Keep the existing state
    partnerDetails,  // Update partnerDetails in state
  })),

  // Handle the RESET_PARTNER action
  on(RESET_PARTNER, () => ({
    ...initState,  // Reset to the initial state
  }))
);
